import { toast } from 'react-toastify';

import { useAppDispatch } from 'redux/store/store.types';
import { getApiErrorMessage } from 'utils';

import { useConnectAccountMutation, useDisconnectAccountMutation } from '../api/hknr-account.api';
import { HknrAccountAC, setHknrAccount } from '../store/hknr-account.slice';
import { ISaveHknrAccountPayload } from '../types/hknr-account.type';

interface UseHknrAccount {
  connectHknrAccountHandler: (payload: ISaveHknrAccountPayload) => Promise<void>;
  disconnectHknrAccountHandler: () => Promise<void>;
}

export const useHknrAccount = (): UseHknrAccount => {
  const dispatch = useAppDispatch();

  const [connectHknrAccountQuery] = useConnectAccountMutation();
  const [disconnectHknrAccountQuery] = useDisconnectAccountMutation();

  const connectHknrAccountHandler = async (payload: ISaveHknrAccountPayload) => {
    dispatch(HknrAccountAC.toggleLoading(true));
    const { data: response, error } = await connectHknrAccountQuery(payload);
    const isError = error || !response;
    dispatch(HknrAccountAC.toggleLoading(false));
    if (isError) {
      toast.error(getApiErrorMessage(error) || 'Failed to connect HKNR account!');
      return;
    }
    dispatch(setHknrAccount(response.data));
    toast.success('Successfully connected HKNR account!');
  };

  const disconnectHknrAccountHandler = async () => {
    dispatch(HknrAccountAC.toggleLoading(true));
    const { error } = await disconnectHknrAccountQuery();
    const isError = error;
    dispatch(HknrAccountAC.toggleLoading(false));
    if (isError) {
      toast.error(getApiErrorMessage(error) || 'Failed to disconnect HKNR account!');
      return;
    }
    dispatch(setHknrAccount(null));
    toast.success('Successfully disconnected HKNR account!');
  };

  return {
    connectHknrAccountHandler,
    disconnectHknrAccountHandler,
  };
};
